import { ForgottenPasswordPage } from './forgotPassword/forgottenPassword';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginPage } from './login/login';
import { RegistrationPage } from './registration/registration';
import { ResetPasswordPage } from './resetPassword/resetPassword';
import { CompleteRegistrationPage } from './completeRegistration/completeRegistration';
import { ToolPage } from './tool/tool';
import { LoginGuard } from './login/login.guard';

const routes: Routes = [
  { path: '', redirectTo: 'tool/null/null', pathMatch: 'full' },
  { path: 'register', component: RegistrationPage },
  { path: 'login', component: LoginPage },
  { path: 'forgotten-password', component: ForgottenPasswordPage },
  { path: 'reset-password/:id/:token', component: ResetPasswordPage },
  { path: 'complete-registration/:token', component: CompleteRegistrationPage },
  { path: 'tool/:brand/:sku', component: ToolPage, canActivate: [LoginGuard] },
  { path: 'tool', redirectTo: 'tool/null/null', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
